import TiposColeta from '../enums/TiposColeta';
const ExcelJS = require('exceljs');

async function exportToExcelCollectOrders(collectOrders) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('CollectOrders');

    // Definindo cabeçalhos
    const headers = [
        'Criado em',
        'Status',
        'ID Coleta',
        'Ref Solicitação',
        'Tipo Coleta',
        'GMO',
        'Endereco Coleta',
        'Cod Sap',
        'Qtd Coleta',
        'Qtd Aceita',
        'Qtd Rejeitada',
        'Solicitante',
        'Coletado em',
        'Sla Coleta',
        'Cód Barras Coletados',        
    ];

    worksheet.addRow(headers);

    // Adicionando dados das requests
    collectOrders.forEach(collectOrder => {

        const createdAtDate = new Date(collectOrder.createdAt);
        let formattedCreatedAt = createdAtDate.toLocaleString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
        // Remove a vírgula
        formattedCreatedAt = formattedCreatedAt.replace(', ', ' ');

        const slaDate = new Date(collectOrder.slaCollectDate);
        let formattedSlaDate = slaDate.toLocaleString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
        // Remove a vírgula
        formattedSlaDate = formattedSlaDate.replace(', ', ' ');

        let formattedDataHoraColeta;

        if(collectOrder.dataHoraColeta){
            const dataHoraColeta = new Date(collectOrder.dataHoraColeta);
            formattedDataHoraColeta = dataHoraColeta.toLocaleString('pt-BR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
            // Remove a vírgula
            formattedDataHoraColeta = formattedDataHoraColeta.replace(', ', ' ');
        }

        const rowData = [
            formattedCreatedAt,
            collectOrder.status,
            collectOrder.idCollectOrder,
            collectOrder.idRequest,
            TiposColeta.find(item => item.cod === collectOrder.tipoColeta).descricao,
            collectOrder.gmo.cidade,
            collectOrder.enderecoColeta,
            collectOrder.codEquipamentoColeta,
            collectOrder.qtdColeta,
            collectOrder.qtdAceita,
            collectOrder.qtdRejeitada,
            collectOrder.nomeSolicitante,
            formattedDataHoraColeta,
            formattedSlaDate,
            collectOrder.codItemsColetados.map(item => item.codigo).join(', '), // Converte os códigos dos itens coletados em uma string separada por vírgulas
        ];
        worksheet.addRow(rowData);
    });

    // Salvar o arquivo Excel
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'collect-orders.xlsx';
    a.click();
    window.URL.revokeObjectURL(url);
}

export default exportToExcelCollectOrders;
